import { Camera, CameraResultType, CameraSource } from '@capacitor/camera'

export const CameraService = {
	async getPhoto(options = {}) {
		const source = options.source === 'library' ? CameraSource.Photos : CameraSource.Camera

		const photo = await Camera.getPhoto({
			quality: options.quality || 80,
			allowEditing: options.allowEdit !== false,
			resultType: CameraResultType.DataUrl,
			source: source,
			correctOrientation: true
		})

		return photo.dataUrl
	},

	async checkPermissions() {
		return await Camera.checkPermissions()
	},

	async requestPermissions() {
		return await Camera.requestPermissions()
	}
}
